module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowExtraLight.b73d807.woff";